import { SetupSummaryPanel, type ReadinessLoad } from '../../../employee-readiness';

export interface SetupSummaryStepProps {
  employeeId: string;
  load: ReadinessLoad;
  onRetry: () => void;
}

/** EPN-94 S1 — Step 5. Read-only: shows what the server says about this employee's payroll readiness and
 * links to where each item is completed. The profile page owns the read (so the header chip and this step
 * share one result); this step only presents it. */
export function SetupSummaryStep({ employeeId, load, onRetry }: SetupSummaryStepProps) {
  return (
    <div className="profile-step-body">
      <div className="profile-step-content">
        <section className="profile-section" aria-labelledby="setup-summary-title">
          <h3 id="setup-summary-title" className="profile-section-title">Setup Summary</h3>
          <SetupSummaryPanel employeeId={employeeId} load={load} onRetry={onRetry} />
        </section>
      </div>
    </div>
  );
}
